module.exports = __webpack_public_path__ + "static/media/warning-sign.cf2a1206.png";